import { Skeleton } from '@/components/ui/skeleton';

export const GuardrailsSkeleton = () => {
  return (
    <div className='w-full mx-auto'>
      <div className='animate-pulse flex space-x-4'>
        <div className='flex-1 space-y-6'>
          <div className='flex flex-col gap-2'>
            <Skeleton className='h-[78px] rounded' />
            <Skeleton className='h-[78px] rounded' />
          </div>
        </div>
      </div>
    </div>
  );
};
